import * as types from "../constants/actionTypes";

export const showGlobalNotification = msg => {
  return {
    type: types.SHOW_GLOBAL_NOTIFICATION,
    payload: {
      show: true,
      msg: msg
    }
  };
};

export const hideGlobalNotification = () => {
  return {
    type: types.HIDE_GLOBAL_NOTIFICATION,
    payload: {
      show: false,
      msg: ""
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/globalNotificationActions.js